import React from 'react';
import styled from 'styled-components';

export const I = styled.i`
    font-family: var(--fontFamilySoehneIkon);
`;

const SocialI = styled(I)`
    font-feature-settings: 'calt';
`;

/*
 * To determine character mapping, you can use the 'Font Book' app or this
 * link: `https://wakamaifondue.com/`
 */
export enum IconType {
    IMG = '&',
    IMG_INV = '@',
    CAM = '£',
    LINK = '%',
    CAM_INV = '^',
    COPY = '*',
    ARROW_UP = '↑',
    ARROW_DOWN = '↓',
    ARROW_LEFT = '←',
    ARROW_RIGHT = '→',
    ARROW_NW = '↖',
    ARROW_NE = '↗',
    ARROW_SE = '↘',
    ARROW_SW = '↙',
    ARROW_UP_DOWN = '↕',
    ARROW_LEFT_RIGHT = '↔',
    REDO = '⭮',
    UNDO = '⭯',
    ARROW_UP_FROM_BAR = '↥',
    ARROW_DOWN_FROM_BAR = '↧',
    DOWNLOAD = '⤓',
    UPLOAD = '⤒',
    CHEVRON_LEFT = '◀',
    CHEVRON_RIGHT = '▶',
    CHEVRON_DOWN = '▼',
    CHEVRON_UP = '▲',
    CHEVRON_UP_DOWN = '⭥',
    CHECKBOX_UNCHECKED = '□',
    CHECKBOX_CHECKED = '☒',
    CHECKBOX_TICKED = '☑',
    CHECKBOX_INDETERMINATE = '⊟',
    RADIO_UNCHECKED = '○',
    RADIO_FULL = '●',
    RADIO_CROSSED = '⮾',
    RADIO_CHECKED = '◉',
    RADIO_INDETERMINATE = '⊖',
    CHEVRON_DOWN_TO_BAR = '⭳',
    HAMBURGER = '☰',
    THEME_TOGGLE = '◑',
    INBOX_TRAY = '📥',
    CROSS = '×',
    PLUS = '+',
    CLOUD_DL = '🌩',
    EXTERNAL_LINK = '⇗',
    ARROW_ANGLE_UP = '⤴',
    BUILD_TIME = '⭍',
    RELOAD = '⥁',
    PLAY = '⏵',
    PAUSE = '⏸',
    STOP = '⏹',
    EDIT = '🖉',
}

export enum SocialIconType {
    INSTAGRAM = 'Ig',
    TWITTER = 'Tw',
    PINTEREST = 'Pn',
    VIMEO = 'Vm',
    TUMBLR = 'Tm',
    FLICKR = 'Fk',
    MASTODON = 'Md',
}

interface IconProps extends React.HTMLAttributes<HTMLElement> {
    type: IconType;
}

export default function Icon({
    type,
    ...props
}: IconProps): React.ReactElement {
    return (
        <I {...props} role="presentation" aria-hidden="true">
            {type}
        </I>
    );
}

interface SocialIconProps extends React.HTMLAttributes<HTMLElement> {
    type: SocialIconType;
}

export function SocialIcon({
    type,
    ...props
}: SocialIconProps): React.ReactElement {
    return <SocialI {...props}>{type}</SocialI>;
}
